var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.4999H7.5M13.2408 12.4082L7.05333 6.21908M2.41083 10.5057L10.0717 2.84491C10.3842 2.53246 10.8081 2.35693 11.25 2.35693C11.6919 2.35693 12.1158 2.53246 12.4283 2.84491L16.5533 6.96991C16.8658 7.28246 17.0413 7.7063 17.0413 8.14824C17.0413 8.59018 16.8658 9.01403 16.5533 9.32658L8.85083 17.0291C8.54926 17.3303 8.14043 17.4996 7.71416 17.4996C7.2879 17.4996 6.87907 17.3303 6.5775 17.0291L2.41083 12.8624C2.09838 12.5499 1.92285 12.126 1.92285 11.6841C1.92285 11.2421 2.09838 10.8183 2.41083 10.5057Z",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErase);
export default __webpack_public_path__ + "static/media/Erase.2ee9589abe9b304f849bb404aca79ab8.svg";
export { ForwardRef as ReactComponent };